import { XrBackendClient, CANONICAL_EVENTS } from '@sdk/zxr-client.js';

/**
 * Puente a API Untitled PS vía SDK existente.
 * Interacciones = eventos canónicos (no hay endpoint /interactions separado).
 * Docs: sdk/README.md | API: https://experience.untitledps.com
 */
export class ChallengeTelemetry {
  /**
   * @param {{ apiBase: string, campaign: string }} options
   */
  constructor(options) {
    this.client = new XrBackendClient(options);
    this.ready = false;
    this.sceneId = 'ar-challenge';
    this.variant = 'ar-interactive-challenge';
    this._errors = [];
  }

  async start() {
    const session = await this.client.start();
    this.ready = true;
    await this.track('experience_opened', {
      scene_id: this.sceneId,
      variant: this.variant,
      device_type: 'webar',
    });
    return session;
  }

  /**
   * @param {import('@sdk/zxr-client.js').CanonicalEventType | string} eventType
   * @param {Record<string, string|number|boolean>} [metadata]
   */
  async track(eventType, metadata = {}) {
    if (!this.ready) return { skipped: true };
    try {
      return await this.client.track(/** @type {any} */ (eventType), {
        scene_id: this.sceneId,
        variant: this.variant,
        ...metadata,
      });
    } catch (err) {
      this._errors.push(String(err?.message || err));
      console.warn('[telemetry]', err);
      return { accepted: false, error: String(err?.message || err) };
    }
  }

  /** Interacción de recolección → game_started con result tap_N (contrato demo). */
  async interaction(tapIndex) {
    return this.track('game_started', {
      result: `tap_${tapIndex}`,
      device_type: 'webar',
    });
  }

  async gameStarted() {
    return this.track('game_started', { result: 'round', device_type: 'webar' });
  }

  async gameFinished({ score, result, durationMs }) {
    return this.track('game_finished', {
      result: String(result || 'done').slice(0, 80),
      duration_ms: Math.min(durationMs, 999999),
      device_type: 'webar',
      // score no cabe como clave libre; va embebido en result
    }).then(async (r) => {
      // Segundo evento con score en result para analítica no autoritativa
      await this.track('cta_clicked', {
        result: `score_${score}`,
        device_type: 'webar',
      });
      return r;
    });
  }

  async tracking(acquired, targetId = 'challenge-target') {
    return this.track(acquired ? 'tracking_acquired' : 'tracking_lost', {
      target_id: targetId,
      device_type: 'webar',
    });
  }

  async share() {
    return this.track('share_clicked', { device_type: 'webar', result: 'capture' });
  }

  get canonicalEvents() {
    return CANONICAL_EVENTS;
  }

  get lastErrors() {
    return [...this._errors];
  }

  clear() {
    this.client.clear();
    this.ready = false;
  }
}
